import React from "react";
import { Route, Redirect } from "react-router-dom";

function RouteIf({ component: Component, condition, redirectPath, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (condition) {
          return <Component {...props} />;
        }

        if (redirectPath === "/intro/main") {
          window.location.href = redirectPath;
          return null;
        }

        return <Redirect to={redirectPath} />;
      }}
    />
  );
}

export default RouteIf;